module.exports = __webpack_public_path__ + "img/Panama.4f191bec.png";